'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import KitTraceabilityHeader from './components/KitTraceabilityHeader';
import KitTraceabilityBoard from './components/KitTraceabilityBoard';

export default function KitTraceabilityPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen bg-background">
        <KitTraceabilityHeader />
        <div className="flex-1 flex flex-col gap-4 p-5 overflow-hidden">
          <KitTraceabilityBoard />
        </div>
      </div>
    </AppLayout>
  );
}
